import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConsentHubLink } from './duck/actions/consentHub';
import { selectConsentHubLink } from './duck/selectors/consentHub';
import { getCurrentContactEmail } from 'modules/auth/selectors';

export const EmailRedirectPage: React.FC = () => {
  const dispatch = useDispatch();

  const consentHubLink = useSelector(selectConsentHubLink);
  const currentContactEmail = useSelector(getCurrentContactEmail);

  useEffect(() => {
    dispatch(fetchConsentHubLink());
  }, [currentContactEmail]);

  useEffect(() => {
    if (consentHubLink) {
      const { preferencesCenterUrl } = consentHubLink;
      window.location.href = preferencesCenterUrl;
    }
  }, [consentHubLink]);

  return null;
};
